"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildProductVariantTitle = exports.pushCheckoutComplete = exports.pushEvent = exports.pushCheckoutStep = void 0;
// Steps
// 1 - Account creation
// 2 - Shipping Address
// 3 - Shipping Method
// Payment & Complete
var pushCheckoutStep = function (lineItems, stepNumber, stepOption, params) {
    if (params === void 0) { params = {}; }
    if (!window.dataLayer)
        return;
    try {
        window.dataLayer.push({
            event: 'checkout',
            ecommerce: {
                actionField: { step: stepNumber, option: stepOption },
                products: dataLayerProductData(lineItems),
            },
        });
    }
    catch (err) {
        console.error("Error pushing checkout complete data to DataLayer", err);
    }
};
exports.pushCheckoutStep = pushCheckoutStep;
var pushEvent = function (eventName, args) {
    if (!window.dataLayer)
        return;
    try {
        var containsDiaperBundle = args.lineItems.some(function (li) { return /Diaper Bundle/i.test(li.title); });
        var containsVitaminBundle = args.lineItems.some(function (li) { return /Vitamin Bundle/i.test(li.title); });
        var containsSubscription = args.lineItems.some(function (li) { return li.properties && !!li.properties.subscription_id; });
        var items = args.lineItems.map(function (li) { return li.title; });
        var totalQty = args.lineItems.map(function (li) { return li.quantity; }).reduce(function (previousValue, currentValue) { return previousValue + currentValue; }, 0);
        var commonDataLayerParams = {
            containsSubscription: containsSubscription,
            priceSubtotal: args.priceSubtotal,
            priceDiscount: args.priceDiscount,
            priceTaxes: args.priceTaxes,
            priceTotal: args.priceTotal,
            containsDiaperBundle: containsDiaperBundle,
            containsVitaminBundle: containsVitaminBundle,
            discountCode: args.discountCode,
            numLineItems: args.lineItems.length,
            items: items,
            totalQty: totalQty,
            alaCartOrder: !containsSubscription,
            phoneNumber: args.phoneNumber,
        };
        window.dataLayer.push(__assign(__assign({ event: eventName }, commonDataLayerParams), args.extras));
    }
    catch (err) {
        console.error("Error pushing event to DataLayer", err);
    }
};
exports.pushEvent = pushEvent;
var pushCheckoutComplete = function (args) {
    if (!window.dataLayer)
        return;
    try {
        window.dataLayer.push({
            ecommerce: {
                purchase: {
                    actionField: {
                        id: args.chargeId,
                        affiliation: 'Online Store',
                        revenue: args.total,
                        tax: args.totalTax,
                        shipping: args.totalShipping,
                        coupon: args.discountCode,
                    },
                    products: dataLayerProductData(args.lineItems),
                },
            },
        });
    }
    catch (err) {
        console.error("Error pushing checkout complete data to DataLayer", err);
    }
};
exports.pushCheckoutComplete = pushCheckoutComplete;
var buildProductVariantTitle = function (productTitle, variantTitle) {
    return {
        key: 'product_variant_title',
        value: "".concat(productTitle, " - ").concat(variantTitle),
    };
};
exports.buildProductVariantTitle = buildProductVariantTitle;
var dataLayerProductData = function (lineItems) {
    return lineItems.map(function (li) {
        return {
            id: li.variant_id,
            name: li.title,
            brand: li.vendor,
            quantity: li.quantity,
            price: (li.price / 100).toFixed(2),
        };
    });
};
